import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import camera from '../../../images/camera.png';

const Footer = () => {
    return (
        <div className='bg-light'>
            <div className='py-5'>
                <Row xs={1} md={2} lg={4} className="g-4">
                    <Col>
                        <Card className='px-5 text-start border-0 bg-light'>
                            <div className='d-flex align-items-center justify-content-start'>
                                <span><Card.Img variant="top" src={camera} alt='Logo' /></span>
                                <Card.Title className='mb-0 ms-2'><span>Wild<span className='text-danger'>life</span> Global</span></Card.Title>
                            </div>
                            <Card.Body className='p-0 mt-2'>
                                <Card.Text style={{ textAlign: 'justify' }}>
                                    Photography is the art of making memories tangible. A portrait is not made in the camera but on either side of it.
                                </Card.Text>
                                <div className='d-flex flex-wrap align-items-center justify-content-around'>
                                    <FontAwesomeIcon className='m-1 fs-4' icon={faFacebook}></FontAwesomeIcon>
                                    <FontAwesomeIcon className='m-1 fs-4' icon={faTwitter}></FontAwesomeIcon>
                                    <FontAwesomeIcon className='m-1 fs-4' icon={faInstagram}></FontAwesomeIcon>
                                    <FontAwesomeIcon className='m-1 fs-4' icon={faYoutube}></FontAwesomeIcon>
                                    <FontAwesomeIcon className='m-1 fs-4' icon={faLinkedin}></FontAwesomeIcon>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='px-5 text-start border-0 bg-light'>
                            <Card.Title className='text-uppercase'>Quick Links</Card.Title>
                            <Card.Body className='p-0'>
                                <Card.Text>About</Card.Text>
                                <Card.Text>Project</Card.Text>
                                <Card.Text>Blog</Card.Text>
                                <Card.Text>Address</Card.Text>
                                <Card.Text>Contact</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='px-5 text-start border-0 bg-light'>
                            <Card.Title className='text-uppercase'>Usefull Links</Card.Title>
                            <Card.Body className='p-0'>
                                <Card.Text>Services</Card.Text>
                                <Card.Text>FAQ</Card.Text>
                                <Card.Text>Legal Information</Card.Text>
                                <Card.Text>Privacy Policy</Card.Text>
                                <Card.Text>Term &amp; Condition</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='px-5 text-start border-0 bg-light'>
                            <Card.Title className='text-uppercase'>Support Links</Card.Title>
                            <Card.Body className='p-0'>
                                <Card.Text>Customer Service</Card.Text>
                                <Card.Text>Bill &amp; Payment Methods</Card.Text>
                                <Card.Text>Privacy Statement</Card.Text>
                                <Card.Text>Social Responsibility</Card.Text>
                                <Card.Text>Support</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            <hr className='m-0' />
            <div className='d-flex flex-wrap align-items-center justify-content-around p-4 fw-semibold'>
                <p className='m-0'>Wild<span className='text-danger'>life</span> Global</p>
                <p className='m-0'>Copyright &copy;{new Date().getFullYear()}. All rights reserved.</p>
            </div>
        </div>
    );
};

export default Footer;